import React from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from './ui/Modal';
import './Vault.css';

/**
 * Cold start's offline screen — multi-device sync Part B
 * (app/plans/01_08_2026/vault-multidevice/PLAN.md §4 row S7, §7).
 *
 * Shown when the probe (or the unlock's own re-fetch) could not reach the
 * server at all — this is deliberately NOT the same as "this account has no
 * vault" (`not_found`), so it never silently falls through to the bootstrap
 * ceremony. "Set up fresh anyway" is an explicit, secondary, clearly-labeled
 * action — never the default — per the loud-refusal-over-quiet-guess rule.
 */
export default function VaultColdStartOfflineScreen({ isOpen, onClose, onRetry, onSetUpFreshAnyway }) {
  const { t } = useTranslation();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="xl"
      title={t('vault.coldStartOfflineTitle', "Can't check for an existing vault")}
    >
      <div className="vault-pass-body">
        <div className="vault-passkey-warn">
          <div className="vault-passkey-warn-text">
            {t(
              'vault.coldStartOfflineBody',
              "This device couldn't reach the server to check whether your account already has a vault on another device. Retry once you're back online — creating a fresh vault now would be the wrong move if one already exists."
            )}
          </div>
        </div>
        <div className="modal-footer-row">
          <button
            type="button"
            onClick={onSetUpFreshAnyway}
            className="px-3 py-1.5 text-gray-600 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors modern-button-secondary text-sm"
          >
            {t('vault.coldStartSetUpFreshAnyway', 'Set up a fresh vault anyway')}
          </button>
          <button
            type="button"
            onClick={onRetry}
            className="px-3 py-1.5 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors modern-button text-sm"
          >
            {t('common.retry', 'Retry')}
          </button>
        </div>
      </div>
    </Modal>
  );
}
